import { useState, useEffect } from 'react'

/**
 * This hook returns a function that allows us to scroll to a specific position on the page
 * Currently the credit card form uses this to scroll down once the form is expanded.
 * We may want to use this in other places and it is pretty reusable.
 */
export const useScrollToPosition = () => {
  const [topPosition, setTopPosition] = useState<number>(0)

  // To scroll to the scroll height and top of the screen
  useEffect(() => {
    const desktopScrollElement = document.getElementById('desktopFormScrollContainer')
    const scrollableElement = desktopScrollElement || window // window is for mobile view, as getElementById is not working there

    scrollableElement?.scrollTo({
      top: topPosition,
      behavior: 'smooth',
    })
  }, [topPosition])

  return { scrollToPosition: setTopPosition }
}
